import React from 'react';
import { FormattedMessage } from 'react-intl';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { Form, Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import selectIsModalOpened from '../../../core/selectors/modal';
import { closeModal } from '../../../core/actions/modal';
import { saveProvider } from '../../actions/sell-tickets';
import { OTHER_PROVIDER_MODAL_NAME } from '../../constants/modal';

const OtherProviderModal = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector((state) => selectIsModalOpened(state, OTHER_PROVIDER_MODAL_NAME));
    const onClose = () => {
        dispatch(closeModal(OTHER_PROVIDER_MODAL_NAME));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const email = e.target.elements.email.value;
        const providerName = e.target.elements.provider.value;
        dispatch(saveProvider(email, providerName));
    };
    return (
        <Modal show={isOpen} onHide={onClose} className="modal-fullscreen-sm-down">
            <Modal.Header closeButton><Modal.Title><FormattedMessage id='other_provider' /></Modal.Title></Modal.Header>
            <Modal.Body>
                <div className="other-provider__container text-center">
                    <div className="other-provider__image rounded-4">
                        <span></span>
                    </div>
                    <div className="other-provider__title text-primary h2 fw-bold">
                        <FormattedMessage id='other_provider__sorry' />
                    </div>
                    <div className="other-provider__text mb-3">
                        <FormattedMessage id='other_provider__sorry__text' />
                    </div>
                    <Form onSubmit={handleSubmit}>
                        <FloatingLabel controlId='provider-name' label={<FormattedMessage id='provider_name'/>} className="mb-3">
                            <Form.Control size="lg" label="provider-name" type="text" placeholder={<FormattedMessage id='provider_name'/>} name='provider'
                                required="required"/>
                        </FloatingLabel>
                        <FloatingLabel controlId='email' label={<FormattedMessage id='your_email'/>} className="mb-3">
                            <Form.Control size="lg" label="Email" type="email" placeholder='Email' name={<FormattedMessage id='your_email'/>} required="required"/>
                        </FloatingLabel>
                        <Button variant="primary" type="submit"><FormattedMessage id='other_provider_notify' /></Button>
                    </Form>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default OtherProviderModal;
